import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as STATUES from 'components/common/constants/reservationStatusConstants';
import { DEPARTURE, RETURN } from 'components/components/booking/utils/FlightConstants';
import moment from 'moment';
import TransHelper from 'components/common/translations/TransHelper';
import Rating from 'react-rating';
import starEmpty from 'components/assets/img/icons/star-empty.svg';
import starFull from 'components/assets/img/icons/star-full.svg';
import T from 'components/common/translations/Translate';
import ReservationUIHelper from 'components/components/dashboard/utils/ReservationUIHelper';

class ReservationNotification extends React.Component {

  trans = (key, vars = null, prefix = 'content.bookingStatus') => {
    return TransHelper.translate(this.props.locale, prefix + "." + key, vars);
  }

  isContent(val) {
    if (val === null || val === '' || val === undefined) {
      return false;
    } else {
      return true;
    }
  }

  getData = () => {
    var helper = new ReservationUIHelper(
      this.props.reservation, this.props.locale, this.props.setReservationToReview
    );
    return helper.getStatusInfo();
  }

  t = (key) => {
    return TransHelper.translate(this.props.locale, key);
  }

  render() {
    const iconGroup = 'fas';
    const { icon, description, moreInfo, type, status } = this.getData();

    return (
      <Fragment>
        <div className={'notification notification--' + `${type}`}>
          <p className="notification__message">
            <FontAwesomeIcon
              icon={[`${iconGroup}`, `${icon}`]}
              className="notification__icon"
            />
            <span className="notification__label">
              {status}:
            </span>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: description }} />
          </p>

          {this.props.reservation.status === STATUES.STATUS_COMPLETED_AND_REVIEWED
            ?
            <div className="more-info">

              <div className="more-info__desc">
                <p><em>{moreInfo}</em></p>
                <span className="user-rating">
                  <Rating
                    emptySymbol={<img src={starEmpty} className="rating__icon" />}
                    fullSymbol={<img src={starFull} className="rating__icon" />}
                    readonly={true}
                    initialRating={this.props.reservation.driver_rate}
                  />
                </span>
              </div>
            </div>
            :
            <p className="notification__message">
              <em>{moreInfo}</em>
            </p>
          }

        </div>
      </Fragment>
    );
  }
}

export default ReservationNotification;
